import { render, staticRenderFns } from "./Wp_mt_order_page.vue?vue&type=template&id=a2d05430&scoped=true&"
import script from "./Wp_mt_order_page.vue?vue&type=script&lang=js&"
export * from "./Wp_mt_order_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d05430",
  null
  
)

export default component.exports